import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { CommonService } from 'src/app/_services/common.service';
import * as moment from "moment";


@Component({
  selector: "app-footer",
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.scss"]
})
export class FooterComponent implements OnInit {
  temppath: string;
  footer: any;
  footer_title: any;
  footer_description: any;
  currentYear: number;
  constructor(private location: Location,private common:CommonService) {
    this.temppath = "./#" + this.location.path();
    this.currentYear = moment().year();
  }

  ngOnInit() {
    // this.common.getFooter().subscribe((data:any) => {
    //   // console.log(data)
    //   this.footer = data[0];
    //   this.footer_title = this.footer.footer_title;
    //   this.footer_description = this.footer.footer_description;
    // })
  }
}
